import React from "react";
import { Helmet } from "react-helmet";

function Contact() {
  return (
    <div className="links container mt-5">
      <Helmet>
        <title>Contact CBSElearn</title>
      </Helmet>
      <h2>Contact</h2>
      <p>
        Reach us through mail.{" "}
        <a href="mailto:yadusurya666@gmail.com">Click here to mail.</a>
      </p>
    </div>
  );
}

export default Contact;
